import { Component, Input } from '@angular/core';
import { RADIO_PLAN_DESC } from '@app/core/models/Radio';
import { LogNav, SetEventProperties } from '@app/core/states/events-tracking.actions';
import { LiveTrackingState } from '@app/core/states/live-tracking.state';
import { RadioState } from '@app/core/states/radio.state';
import { BacGroup } from '@app/library/models/bac.model';
import { AMPLITUDE_EVENT } from '@app/shared/amplitude-events';
import { formatTrackingNavName } from '@app/shared/utils';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-library-bac-group',
  templateUrl: './library-bac-group.component.html',
  styleUrls: ['./library-bac-group.component.scss'],
})
export class LibraryBacGroupComponent {
  @Input()
  groupBac: BacGroup;

  @Select(RadioState.currentRadioId)
  myRadioId$: Observable<number>;

  @Select(LiveTrackingState.planDesc)
  planDesc$: Observable<RADIO_PLAN_DESC>;

  @Input()
  radioId: number;

  constructor(private readonly store: Store) {}

  trackClickTrash() {
    this.store.dispatch(
      new SetEventProperties({
        name: formatTrackingNavName('subnav-library-trash'),
      }),
    );
    this.store.dispatch(new LogNav(AMPLITUDE_EVENT.NAV.CLICK_SUBNAV));
  }
}
